module.exports = __webpack_public_path__ + "img/metal_b@2x.93d54001.png";